<template>
  <div>
    <a-layout-content style="padding: 0 20px; height: 100%">
      <a-row type="flex" style="height: 100%">
        <a-col :span="5" :order="1" style="height: 100%">
          <div
            class="w-64 px-2 overflow-y-auto scroll-box h-screen code-box"
            style="height: 100%"
          >
            <a-input-search
              v-model:value="filterKeyWord"
              style="margin-bottom: 8px"
              :placeholder="getLanguage('输入区域或设备名称筛选')"
            />
            <a-tree
              class="draggable-tree"
              draggable
              block-node
              :autoExpandParent="autoExpandParent"
              :expanded-keys="expandedKeys"
              :tree-data="treeData"
              @expand="onExpand"
              @select="selectTree"
            >
              <template #title="{ title }">
                <span v-if="getTranslation(title).indexOf(filterKeyWord) > -1">
                  {{
                    getTranslation(title).substr(
                      0,
                      getTranslation(title).indexOf(filterKeyWord)
                    )
                  }}
                  <span style="color: #f50">{{ filterKeyWord }}</span>
                  {{
                    getTranslation(title).substr(
                      getTranslation(title).indexOf(filterKeyWord) +
                        filterKeyWord.length
                    )
                  }}
                </span>
                <span v-else>{{ getTranslation(title) }}</span>
              </template>
            </a-tree>
          </div>
        </a-col>
        <a-col :span="19" :order="2">
          <div
            class="freqx_formTitle"
            v-if="currentMachine && currentMachine.title"
          >
            {{ getTranslation(currentMachine.title) }}
          </div>
          <div class="main" v-if="currentMachine && dataSource.length">
            <a-table
              bordered
              :columns="columns"
              :data-source="dataSource"
              :pagination="false"
              :loading="loading"
              @change="handleTableChange"
              size="small"
            >
              <template #bodyCell="{ column, text, record }">
                <template v-if="column.dataIndex === 'sensorPlace'">
                  {{ getTranslation(text) }}
                </template>
                <template v-if="column.dataIndex === 'groupName'">
                  {{ getTranslation(text) }}
                </template>
                <template v-if="column.dataIndex === 'machineName'">
                  {{ getTranslation(text) }}
                </template>
                <template v-if="column.dataIndex === 'wave_delay'">
                  <div class="redpoint" v-if="text"></div>
                  <div class="greenpoint" v-else></div>
                  <span v-if="text">{{ getLanguage("是") }}</span>
                  <span v-else>{{ getLanguage("否") }}</span>
                </template>
                <template v-if="column.dataIndex === 'index_delay'">
                  <div class="redpoint" v-if="text"></div>
                  <div class="greenpoint" v-else></div>
                  <span v-if="text">{{ getLanguage("是") }}</span>
                  <span v-else>{{ getLanguage("否") }}</span>
                </template>
                <template v-if="column.dataIndex === 'peak_vol'">
                  {{ text ? text + "V" : "--" }}
                </template>
                <template v-if="column.dataIndex === 'bind'">
                  <div class="greenpoint" v-if="text"></div>
                  <div class="redpoint" v-else></div>
                  <span v-if="text">{{ getLanguage("是") }}</span>
                  <span v-else>{{ getLanguage("否") }}</span>
                </template>
                <template v-if="column.dataIndex === 'vol'">
                  {{ text || text == 0 ? text + " %" : "" }}
                </template>
              </template>
            </a-table>
          </div>
          <div v-if="!currentMachine || !dataSource.length">
            <a-alert
              :message="getLanguage('未选择设备或没有配置测点')"
              type="warning"
              show-icon
            />
          </div>
        </a-col>
      </a-row>
    </a-layout-content>
  </div>
</template>

<script lang="ts" setup>
import request from "../../common/request";
import { useRouter } from "vue-router";
import { computed, onMounted } from "vue";
import { ref, reactive, watch } from "vue";
import type { UploadProps } from "ant-design-vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
const router = useRouter();
const loading = ref(false);
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
import { getLanguage, getTranslation } from "@/common/translate";
operateLogs("Access sensor management");
/**操作日志记录 */

/**表单校验 */
const formStateRef = ref();
const clearValidate = (name: any) => {
  formStateRef.value.clearValidate(name);
};

/**表单校验 */

const formState = reactive({
  keyword: "",
  factory: "",
  skip: 1,
  take: 10,
});

const modalState = reactive({
  visible: false,
  title: "新增",
  confirmLoading: false,
  roleName: "",
  meun: [],
});

const pagination = computed(() => ({
  total: 200,
  current: formState.skip,
  pageSize: formState.take,
}));

const dataSource: any = ref([]);
const columns = [
  {
    title: getLanguage("区域"),
    dataIndex: "groupName",
  },

  {
    title: getLanguage("设备名称"),
    dataIndex: "machineName",
  },
  {
    title: getLanguage("测点"),
    dataIndex: "sensorPlace",
  },

  // {
  //     title: getLanguage('传感器类型'),
  //     dataIndex: "config_type",
  // },
  {
    title: getLanguage("数据延迟"),
    dataIndex: "index_delay",
  },
  // {
  //     title: getLanguage('波形数据延迟'),
  //     dataIndex: "bx",
  // },
  // {
  //     title: getLanguage('指标数据延迟'),
  //     dataIndex: "zb",
  // },
  {
    title: getLanguage("电压"),
    dataIndex: "peak_vol",
  },
  {
    title: getLanguage("电量"),
    dataIndex: "bat_vol",
  },
];
let treeData = ref<any>();
let allFactory: any = ref([]);
const deleteThis = (val: any) => {
  const config = {
    params: { id: val.id },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.delete("/api/sensors/info", config).then((res) => {
    if (res) {
      operateLogs(
        "删除测点信息，测点安装位置：" + val.sensorPlace + ",测点id:" + val.id
      );
      message.success(getLanguage("操作成功"));
      search();
    } else {
    }
  });
};
const editThis = (val: any) => {
  searchSensor();
  modalState.visible = true;
  modalState.title = "编辑";
  addFormState.value = JSON.parse(JSON.stringify(val));
};
// 新增
const add = () => {
  searchSensor();
  modalState.title = "新增";
  addFormState = ref({
    machineIdList: [],
    sensorPlace: "",
    sensorGroup: [], // 参数
    sensorSn: "", //
    remark: "",
    sort: 0,
    dataType: [],
    machineTypeId: 0, // 暂时无需
    fcSensorId: "",
    fcSensorPlace: "",
    partId: 0, // 暂时无需
    machineId: "",
    id: 0,
  });
  modalState.visible = true;
};

let currentMachine = ref<any>();

const handleTableChange = (val: any) => {};
// 查询
const search = (type:any, key:any) => {
  // if (!currentMachine.value && !currentMachine.value.key) {
  //   return;
  // }
  const config = {
    params: {
      take: 2000,
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  config.params.factoryId = localStorage.getItem("factory_id");
  if (type == 0) {
    config.params.factoryId = key;
  } else if (type == 1) {
    config.params.groupId = key;
  } else if (type == 2) {
    config.params.machineId = key;
  }
  request.get("/api/external/hardware/sensor/list", config).then((res: any) => {
    if (res) {
      dataSource.value = res.data.list;
    }
  });
};
let sensorList = ref<any>([]);
const searchSensor = async () => {
  const config = {
    params: { machineId: currentMachine.value.key },
    headers: {
      requestId: uuidv4(),
    },
  };
  await request.get("/api/sensors", config).then(async (res: any) => {
    if (res) {
      sensorList.value = res.data.map((t: any) => ({
        ...t,
        key: t.id,
        label: t.sensorPlace + "-" + t.sensorSn,
        value: t.id,
      }));
    }
  });
};

//**图片上传* */
const previewVisible = ref(false);
const previewImage = ref("");
const previewTitle = ref("");
const fileList = ref<UploadProps["fileList"]>([]);
const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = "";
};
const handlePreview = async (file: UploadProps["fileList"][Number]) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string;
  }
  previewImage.value = file.url || file.preview;
  previewVisible.value = true;
  previewTitle.value =
    file.name || file.url.substring(file.url.lastIndexOf("/") + 1);
};
function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

/**新增编辑功能 */
let addFormState = ref({
  machineIdList: [],
  sensorPlace: "",
  sensorGroup: [], // 参数
  sensorSn: "", //
  remark: "",
  sort: 0,
  dataType: [],
  machineTypeId: 0, // 暂时无需
  fcSensorId: "",
  fcSensorPlace: "",
  partId: 0, // 暂时无需
  machineId: "",
  id: 0,
});

const columnsForm = [
  {
    title: "编号",
    dataIndex: "sonId",
  },
  {
    title: "安装坐标",
    dataIndex: "coordinate",
  },
  {
    title: "名称",
    dataIndex: "sensorGroupName",
  },
  {
    title: "操作",
    dataIndex: "act",
  },
];

// 保存
const handleOk = () => {
  // if (addFormState.value.machineIdList.length) {
  //   addFormState.value.machineId =
  //     addFormState.value.machineIdList[
  //       addFormState.value.machineIdList.length - 1
  //     ];
  // }
  formStateRef.value
    .validate()
    .then((result: any) => {
      addFormState.value.machineId = currentMachine.value.id;
      if (addFormState.value.id) {
        const config = {
          headers: {
            requestId: uuidv4(),
          },
        };
        request
          .put("/api/sensors/info", addFormState.value, config)
          .then((res) => {
            if (res) {
              operateLogs(
                "修改测点信息，测点安装位置：" +
                  addFormState.value.sensorPlace +
                  ",测点id:" +
                  addFormState.value.id
              );
              modalState.visible = false;
              message.success(getLanguage("操作成功"));
              search();
            }
          });
      } else {
        const config = {
          headers: {
            requestId: uuidv4(),
          },
        };
        request.post("/api/sensors", addFormState.value, config).then((res) => {
          if (res) {
            operateLogs(
              "添加测点信息，测点安装位置：" + addFormState.value.sensorPlace
            );
            modalState.visible = false;
            message.success(getLanguage("操作成功"));
            search();
          }
        });
      }
    })
    .catch((err: any) => {
      console.log(err); //失败后执行
    });
};

const addParams = () => {
  addFormState.value.sensorGroup.push({
    sonId: "",
    coordinate: "",
    sensorGroupName: "",
  });
};

const filter: any = (inputValue: any, path: any) => {
  console.log(path);
  return path.some(
    (option: { title: string }) => option.title.indexOf(inputValue) > -1
  );
};
const deleteGroup = (index: any) => {
  addFormState.value.sensorGroup.splice(index, 1);
};

/* 左侧区域-设备 数据加载 */
// 在组件加载完成后执行一些操作\
const selectTree = (key: any, val: any) => {
  console.log(key, val);
  if (val.node.type == "machine") {
    currentMachine.value = val.node;
    search(2, val.node.value);
  } else if (val.node.type == "factory") {
    currentMachine.value = val.node;
    search(0, val.node.value);
  } else if (val.node.type == "group") {
    search(1, val.node.value);
  }
};

const cascaderChange = (key: any, val: any) => {
  console.log(key);
  if (val) {
  }
};

// onMounted(() => {
//   loadFactory();
// });
let filterKeyWord = ref<any>();
// const loadFactory = () => {
//   const config = {
//     params: { factoryId: factoryId },
//     headers: {
//       requestId: uuidv4(),
//     },
//   };
//   request.get("/api/factories/info", config).then((res: any) => {
//     if (res) {
//       groupList.value =res.data.groups
//       loadMachine();
//     }
//   });
// };
const onExpand = (keys: string[]) => {
  expandedKeys.value = keys;
  autoExpandParent.value = false;
};
const expandedKeys = ref<(string | number)[]>([]);
const autoExpandParent = ref<boolean>(true);

watch(filterKeyWord, (value) => {
  expandedKeys.value = [];
  sonKey(treeData.value, "");
  autoExpandParent.value = true;
  console.log(expandedKeys.value);
});
const sonKey = (item: any, key: any) => {
  item.forEach((element: any) => {
    if (element.title.indexOf(filterKeyWord.value) > -1) {
      // expandedKeys.value.push(key);
      expandedKeys.value.push(element.key);
    }
    if (element.children && element.children.length) {
      sonKey(element.children, element.key);
    }
  });
};
const getParentKey = (
  key: string | number,
  tree: any
): string | number | undefined => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (
        node.children.some((item: { key: string | number }) => item.key === key)
      ) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};
let dataTypeList = ref<any>();

const loadDatatype = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/sensors/datatype", config).then((res: any) => {
    if (res) {
      dataTypeList.value = res.data.map((t: any) => ({
        value: t.name,
        label: t.name,
      }));
    }
  });
};
loadDatatype();
let machinesTypeList = ref<any>([]);
const loadmachinestype = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/sensors/machine-types", config).then((res: any) => {
    if (res) {
      var firstList;
      var result = res.data;
      if (result) {
        firstList = result.map((d: any) => d.FirstCategory);
        firstList = [...new Set(firstList)];
      }

      firstList.forEach((d: any) => {
        let first = {
          value: d,
          label: d,
          children: Array(0),
        };

        let secondList = result
          .filter((p: any) => p.FirstCategory === d)
          .map((p: any) => p.SecondCategory);
        secondList = [...new Set(secondList)];

        secondList.forEach((d2: any) => {
          let second = {
            value: d2,
            label: d2,
            children: Array(0),
          };

          let thirdList = result.filter((p: any) => p.SecondCategory === d2);
          thirdList.forEach((d3: any) => {
            let third = {
              value: d3.ThirdCategory,
              label: d3.ThirdCategory,
              isLeaf: true,
            };
            second.children.push(third);
          });

          first.children.push(second);
        });

        machinesTypeList.value.push(first);
      });
      machinesTypeList.value = [...machinesTypeList.value];
    }
  });
};
loadmachinestype();
//***角色车间***//
onMounted(() => {
  var requestId = uuidv4();
  loadFactory(requestId);
});

let factoryList = ref<any>();

const loadFactory = (requestId: any) => {
  const config = {
    params: {},
    headers: {
      requestId: requestId,
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {
      allFactory.value = res.data;
      // 2级工厂
      var list = res.data.map((t: any) => ({
        key: t._id,
        title: t.factoryName,
        value: t._id,
        label: t.factoryName,
        parentId: t.parentId,
        id: t._id,
        type: "factory",
        children: t.groups.map((group: any) => ({
          type: "group",
          value: group.sonID,
          label: group.name,
          title: group.name,
          key: group.sonID,
        })),
      }));
      let factory: any = [];
      let parentFs = list.filter((p: any) => !p.parentId);
      parentFs.map((d: any) => {
        let sonFactory = list.filter((p: any) => p.parentId === d.id);
        if (sonFactory && sonFactory.length) {
          d.children = sonFactory;
        }
        factory.push(d);
      });
      factoryList.value = factory;
      loadMachine(requestId);
    }
  });
};
const loadMachine = async (requestId: any) => {
  let factoryIds = allFactory.value.map((p: any) => p._id);
  let res = await request.post("/api/machines/all", { factoryIds });

  factoryList.value.forEach((element: any) => {
    if (res) {
      element.children.forEach((sonFact: any) => {
        if (sonFact.type == "factory" && sonFact.children) {
          sonFact.children.forEach((groupFact: any) => {
            if (groupFact.type == "group") {
              groupFact.children = res.data
                .filter((t: any) => t.groupId == groupFact.value)
                .map((t: any) => ({
                  type: "machine",
                  ...t,
                  value: t.id,
                  label: t.machineName,
                  title: t.machineName,
                  key: t.id,
                }));
            }
          });
        } else if (sonFact.type == "group") {
          sonFact.children = res.data
            .filter((t: any) => t.groupId == sonFact.value)
            .map((t: any) => ({
              type: "machine",
              ...t,
              value: t.id,
              label: t.machineName,
              title: t.machineName,
              key: t.id,
            }));
        }
      });
    }
  });

  setTimeout(() => {
    treeData.value = factoryList.value;
  }, 100);
};
const selectSensor = (val: any, val2: any) => {
  console.log(val);
  console.log(val2);
  addFormState.value.fcSensorPlace = val2.sensorPlace;
};
</script>
<style scoped>
.greenpoint {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: green;
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 5px;
}

.redpoint {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: red;
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 5px;
}

.spanbtn {
  margin-top: 10px;
}

.code-box {
  position: relative;
  display: inline-block;
  width: 90%;
  margin: 0 0px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  transition: all 0.2s;
  padding: 15px;
}

.main {
  margin-top: 30px;
}
</style>